const common = {
  search: 'Search...',
  select: 'Select',
  selectDropdown: 'Select...',
  loading: 'Loading...',
  selected: '{{count}} Selected ',
  noOptions: 'No options',
  all: 'All',
  allWithName: 'All {{name}}',
  add: 'Add',
  selectAll: 'Select All',
  unselectAll: 'Unselect All',
  enter: 'Enter',
  items: '{{count}} Items, ',
  shortWeekdays: ['M', 'T', 'W', 'T', 'F', 'S', 'S'],
  distanceType: {
    metric: 'Km',
    imperial: 'Mi',
  },
  hour: 'Hour',
  reductions: {
    h: 'h',
    m: 'm',
    s: 's',
  },
  connectorStatus: {
    free: 'Available',
    busy: 'Unavailable',
    unknown: 'Unknown',
    error: 'Broken',
  },
  yes: 'Yes',
  no: 'No',
  weekDays: {
    sunday: 'sunday',
    monday: 'monday',
    tuesday: 'tuesday',
    wednesday: 'wednesday',
    thursday: 'thursday',
    friday: 'friday',
    saturday: 'saturday',
  },
  internal: 'Internal',
  google: 'Google',
  operationAddress: {
    student: 'Student Address',
    employee: 'Employee Address',
  },
  map: {
    zoomIn: 'Zoom In',
    zoomOut: 'Zoom Out',
    fullScreen: 'Full-Screen',
    polygon: {
      exceededModal: {
        body: 'The circumference of a "Block" area cannot exceed 10km',
        cancel: 'Cancel',
      },
      deleteModal: {
        header: 'Delete Polygon?',
        body: 'You are about to delete the polygon',
      },
    },
  },
  roles: {
    // Keys are all lowercase due to processing that handles role names provided by the backend as space-separated strings.
    dispatchadmin: 'dispatch admin',
    dispatcher: 'dispatcher',
    superagent: 'Super Agent',
    agent: 'Agent',
    supplier: 'Supplier',
    superadmin: 'Super Admin',
    accountingadmin: 'Accounting Admin',
    accountant: 'Accountant',
    companyadmin: 'Company admin',
    admin: 'Admin',
  },
  duration: 'Duration',
  distance: 'Distance',
};

export default common;
